import React from 'react';
import propTypes from 'prop-types';
import Select from 'react-select';
import api from '../../../../utils/Api';
import { AUTH_TOKEN_KEY } from '../../../../constants';

class SelectRaffleGroup extends React.Component{
  constructor(props){
    super(props);
    this.loadSelectOptions = this.loadSelectOptions.bind(this);
    this._getVariantOptions = this._getVariantOptions.bind(this);
  }

  cache = {}

  loadSelectOptions(input){
    return this.refs[this.props.id].loadOptions(input);
  }

  purgeCache = () => {
    Object.keys(this.cache).forEach(entry => {
      delete this.cache[entry]
    })
  }

  _getVariantOptions(input){
    const myToken = localStorage.getItem(AUTH_TOKEN_KEY);
    const headers = {
      'Authorization': `Bearer ${myToken}`
    };
    const params = {
      keyword: input,
      active: 1,
      ...this.props.paramsApi
    }
    return api(headers).get('/admins/raffle-groups', { params })
    .then(({ data }) => {
      const products = data.data.data.map(item=>{
        return {
          id: item.id,
          name: item.name
        }
      })
      if(this.props.onSelectSearch){
        this.props.onSelectSearch(input)
      }
      return { options: products };
    });
  }

  render(){
    return(
      <Select.Async
        valueKey="id"
        labelKey="name"
        ref={this.props.id}
        loadOptions={this._getVariantOptions}
        cache={this.cache}
        id={this.props.id}
        name={this.props.name}
        value={this.props.value}
        placeholder={this.props.placeholder}
        noResultsText={this.props.noResultsText}
        onChange={this.props.onSelectChange}
        onOpen={this.props.onSelectOpen}
        multi={this.props.isMulti}
      />
    )
  }
}

export default SelectRaffleGroup;

SelectRaffleGroup.defaultProps = {
  cacheOptions: false,
  value: null,
  placeholder: 'Select a raffle group...',
  noResultsText: 'No Result!',
  paramsApi: {}
}

SelectRaffleGroup.propTypes = {
  id: propTypes.string.isRequired,
  name: propTypes.string,
  value: propTypes.object,
  placeholder: propTypes.string,
  noResultsText: propTypes.string,
  cacheOptions: propTypes.bool,
  paramsApi: propTypes.object,
  onSelectSearch: propTypes.func,
  onSelectChange: propTypes.func,
  onSelectOpen: propTypes.func
}